import {RenderingServices} from '@wallaby-ui/core';

import styles from 'src/js/containers/encounter/components/EventAnnotationType.less';
import {
  baseEventAnnotationTypeParams,
  BaseEventAnnotationTypeParams,
} from 'src/js/lib/raw_rendering/base_event_annotation_type_params';

/**
 * Returns raw Html element version of EventAnnotationType component.
 * @param params
 * @param services
 * @returns {String}
 */
export function eventAnnotationTypeRenderer(
  params: BaseEventAnnotationTypeParams,
  services: RenderingServices = {}
) {
  const {annotationLabel} = baseEventAnnotationTypeParams(params, services);

  return `<div class="${styles.dlEventAnnotationType}">
            ${annotationLabel}
        </div>`;
}
